(function($) {
    $(() => {
        const slider = $('.case_studies_slider');

        slider.on('init reInit', function(event, slick) {
            $('.case_studies_slider__total-count').html(`1/${slick.slideCount}`);
        });

        slider.on('afterChange', function (event, slick, currentSlide) {
            $('.case_studies_slider__total-count').html(`${currentSlide + 1}/${slick.slideCount}`);
        });

        slider.slick(
            {
                infinite: false,
                slidesToShow: 2,
                arrows: false,
                nextArrow:  $('.case_studies_slider__right'),
                prevArrow:  $('.case_studies_slider__left'),
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1,
                            arrows: true,
                            infinite: true,
                        }
                    }
                ]
                // nextArrow:  $('.testimonial-card__right'),
                // prevArrow:  $('.testimonial-card__left'),
            }
        );

        $('#load-more-studies').on('click', function () {
            let shown = 0;
            const toShow = $(this).data('toshow');
            $('.hidden').each(function(i) {
                if (i < toShow) {
                    $(this).removeClass('hidden');
                }
            });

            if (!$('.hidden').length) {
                $(this).parent().parent().remove();
            }
        });
    });
})(jQuery);